package com.xtream.ui.tv.presentation.prefs

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.focusGroup
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.calculateStartPadding
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.Logout
import androidx.compose.material.icons.filled.ColorLens
import androidx.compose.material.icons.filled.DeleteSweep
import androidx.compose.material.icons.filled.Https
import androidx.compose.material.icons.filled.PhotoSizeSelectLarge
import androidx.compose.material.icons.filled.SwapVert
import androidx.compose.material.icons.filled.Timelapse
import androidx.compose.material.icons.filled.Translate
import androidx.compose.material.icons.filled.VideoSettings
import androidx.compose.material.icons.filled.Visibility
import androidx.compose.material.icons.filled.WatchLater
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.adaptive.ExperimentalMaterial3AdaptiveApi
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusDirection
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.composeapp.theme.AppTheme
import com.xtream.composeapp.viewmodel.AppSettingsViewModel
import com.xtream.composeapp.viewmodel.SeriesViewModel
import com.xtream.composeapp.viewmodel.UserViewModel
import com.xtream.composeapp.viewmodel.VodStreamsViewModel
import com.xtream.composeapp.viewmodel.livetv.LiveStreamsViewModel
import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.db.tables.StreamType
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.always_use_https
import com.xtream.sharedResources.resources.always_use_https_desc
import com.xtream.sharedResources.resources.chose_app_theme
import com.xtream.sharedResources.resources.chose_language
import com.xtream.sharedResources.resources.clear_watched_live_tv_history
import com.xtream.sharedResources.resources.clear_watched_movies_history
import com.xtream.sharedResources.resources.clear_watched_series_history
import com.xtream.sharedResources.resources.general
import com.xtream.sharedResources.resources.language
import com.xtream.sharedResources.resources.language_keys
import com.xtream.sharedResources.resources.language_titles
import com.xtream.sharedResources.resources.live
import com.xtream.sharedResources.resources.live_stream_formats
import com.xtream.sharedResources.resources.logout
import com.xtream.sharedResources.resources.movies
import com.xtream.sharedResources.resources.no
import com.xtream.sharedResources.resources.player
import com.xtream.sharedResources.resources.refresh_data_interval
import com.xtream.sharedResources.resources.refresh_data_intervals
import com.xtream.sharedResources.resources.refresh_data_intervals_values
import com.xtream.sharedResources.resources.refresh_playlist_title
import com.xtream.sharedResources.resources.reorder_tv_channels
import com.xtream.sharedResources.resources.resume_last_playback_desc
import com.xtream.sharedResources.resources.resume_last_played_activity
import com.xtream.sharedResources.resources.series
import com.xtream.sharedResources.resources.settings
import com.xtream.sharedResources.resources.show_and_hide_categoires
import com.xtream.sharedResources.resources.stream_format
import com.xtream.sharedResources.resources.theme
import com.xtream.sharedResources.resources.theme_titles
import com.xtream.sharedResources.resources.user_data
import com.xtream.sharedResources.resources.video_player_resize_mode_titles
import com.xtream.sharedResources.resources.video_player_resize_modes
import com.xtream.sharedResources.resources.video_render_mode
import com.xtream.sharedResources.resources.video_render_mode_titles
import com.xtream.sharedResources.resources.video_render_modes
import com.xtream.sharedResources.resources.video_scaling_mode
import com.xtream.sharedResources.resources.yes
import com.xtream.ui.data.PreferenceAction
import com.xtream.ui.data.PreferenceButtonAction
import com.xtream.ui.data.PreferenceCategoryAction
import com.xtream.ui.data.PreferenceChoiceAction
import com.xtream.ui.data.PreferenceRadioAction
import com.xtream.ui.data.PreferenceSwitchAction
import com.xtream.ui.data.PreferenceType
import com.xtream.ui.platform.isDpadNavigation
import com.xtream.ui.ui.component.extension.endFocusDirection
import com.xtream.ui.ui.component.extension.startFocusDirection
import com.xtream.ui.ui.preference.InTvChoiceButtons
import com.xtream.ui.ui.preference.InTvRadioButton
import com.xtream.ui.ui.preference.SettingsComposeScreen
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringArrayResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel


@Composable
fun ComposeSettingsTvScreen(

    navKey: Screen.Settings,

    contentPadding: PaddingValues,
    ){


    val preferencesList = rememberPreferencesList( navKey = navKey)

val focusManager = LocalFocusManager.current
val endDirection= FocusDirection.endFocusDirection()
    val layoutDirection = LocalLayoutDirection.current



// 1. Store only the ID (or key) of the selected preference
    var selectedPrefKey by remember { mutableStateOf<String?>(null) }

// 2. Derive the actual object from the list using the key
    val selectedPref = remember(selectedPrefKey, preferencesList) {
        preferencesList.find { it.key == selectedPrefKey }
    }

    @OptIn(ExperimentalMaterial3AdaptiveApi::class)
    Row(

        modifier = Modifier
            .fillMaxHeight(),


        content = {
            SettingsComposeScreen(
                contentPadding = PaddingValues(start = contentPadding.calculateStartPadding(layoutDirection), end = 48.dp, bottom = 48.dp),

                onClick = {
                    focusManager.moveFocus(endDirection)
                },
                onFocused = {pref->

// 3. Update the key, not the object
                    selectedPrefKey = pref.key
                },
                modifier = Modifier
                    .clickable(false, onClick = {})
                    .background(MaterialTheme.colorScheme.secondaryContainer)
                   // .padding(start = contentPadding.calculateStartPadding(layoutDirection))
                    .weight(1f)
                    .fillMaxHeight()
                    .padding(top = 24.dp),
                containerColor = Color.Transparent,
                title = stringResource(Res.string.settings),
                preferences = preferencesList,
            )
                PrefDetailScreen(
                    modifier = Modifier
                        .weight(1f)
                        .padding(top = 48.dp)
                        .fillMaxHeight(),
                    preferences = selectedPref
                )

        }
    )









    LaunchedEffect(preferencesList) {
        if (selectedPrefKey == null) {
            selectedPrefKey = preferencesList
                .firstOrNull { it !is PreferenceCategoryAction }?.key
        }
    }

}


@Composable
private fun PrefDetailScreen(
    preferences: PreferenceAction?,
    modifier: Modifier = Modifier,
    contentPadding: PaddingValues = PaddingValues(48.dp, 24.dp)
){
    val focusManager = LocalFocusManager.current
    val startDirection= FocusDirection.startFocusDirection()
    val layoutDirection = LocalLayoutDirection.current



    Scaffold (
        modifier = modifier,
        topBar = {

                    Text(
                        modifier = Modifier.fillMaxWidth().padding(start = contentPadding.calculateStartPadding(layoutDirection)),
                        text = preferences?.title?.let { title->
                            stringResource(title)
                        }?:"")

        },


        ){innerPadding->
        val groupFocusRequester = remember { FocusRequester() }
        val  focusRequester = remember { FocusRequester() }

        LazyColumn (
            modifier = Modifier
                .padding(innerPadding)
                .focusGroup()
                .focusRequester(groupFocusRequester)
                .focusRestorer (
                    focusRequester
                )
                ,
            verticalArrangement =  Arrangement.spacedBy(12.dp),
            contentPadding = contentPadding,


            ) {


            when(preferences){
                is PreferenceButtonAction,is PreferenceSwitchAction -> item {
                    Text( preferences.description?.let { stringResource(it) }?:"",
                        style = MaterialTheme.typography.bodyMedium,modifier = Modifier
                            .clip(MaterialTheme.shapes.medium)
                            .background(
                                MaterialTheme.colorScheme.secondaryContainer
                            )
                            .padding(16.dp) )
                }


                is PreferenceChoiceAction -> itemsIndexed(
                    preferences.options.toList(),
                    key = { index,item-> "$index-${item.first}"}
                    ) { index, it->
                    val title = (it.second as? StringResource?)?.let { res->
                        stringResource(res)

                    }?: it.toString()
                    InTvChoiceButtons(
                        modifier= Modifier
                            .then(
                                if (index == 0)
                                    Modifier.focusRequester(focusRequester)
                                else
                                    Modifier

                            )
                            .fillMaxWidth(),
                        title = title,

                        onConfirmation = {_,_->
                            focusManager.moveFocus( startDirection)
                            preferences.onItemSelected?.invoke(it.first, title)

                        },
                        choiceAction = preferences

                    )


                }

                is PreferenceRadioAction -> itemsIndexed(
                    preferences.options.toList(),
                    key = { index,item-> "$index-${item.first}"}


                ) { index, it->

                  val  prefValueState = preferences.currentValue

                   // Log.d("prefValueState", "PrefDetailScreen: ${prefValueState?.value?.javaClass}, ${it.first?.javaClass}, is equal: ${prefValueState?.value == it.first}")
                    InTvRadioButton(
                        modifier= Modifier
                            .then(
                                if (index == 0)
                                    Modifier.focusRequester(focusRequester)
                                else
                                    Modifier

                            )
                            .fillMaxWidth(),
                        value = it.second.toString(),
                        selected = it.first == prefValueState,
                        key = it.first,
                        onConfirmation = {_,_->
                            preferences.onItemSelected?.invoke(it.first, it.second)



                        }

                    )
                }

            }


        }
    }
}

@Composable
fun rememberPreferencesList(navKey: Screen.Settings): List<PreferenceAction> {

    // ── ViewModels ────────────────────────────────────────────────────────────
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner

    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner = viewModelStoreOwner?: error("no viewModelStoreOwner provided")
    )

    val userViewModel: UserViewModel = koinViewModel()
    val appSettingsViewModel: AppSettingsViewModel = koinViewModel()
    val liveStreamsViewModel: LiveStreamsViewModel = koinViewModel()
    val vodStreamsViewModel: VodStreamsViewModel = koinViewModel(
        key = "vodStream_${navKey::class.simpleName}_${navKey.hashCode()}"
    )
    val seriesStreamsViewModel: SeriesViewModel = koinViewModel(
        key = "seriesStream_${navKey::class.simpleName}_${navKey.hashCode()}"
    )

     val scope = rememberCoroutineScope()

    // ── Collect all state upfront — single source of truth for the list ───────
    val language        by appSettingsViewModel.languageFlow.collectAsStateWithLifecycle(null)
    val appTheme        by appSettingsViewModel.appThemeFlow.collectAsStateWithLifecycle(null)
    val resumeEnabled   by appSettingsViewModel.resumeLastPlayedActivityEnabledFlow.collectAsStateWithLifecycle(false)
    val alwaysHttps     by appSettingsViewModel.alwaysUseHttpsFlow.collectAsStateWithLifecycle(false)
    val streamFormat    by appSettingsViewModel.liveStreamFormatFlow.collectAsStateWithLifecycle(".ts")

     val scalingMode     by appSettingsViewModel.videoScalingModeFlow.collectAsStateWithLifecycle(0/*AspectRatioFrameLayout.RESIZE_MODE_FILL*/)
    val renderMode      by appSettingsViewModel.videoRenderModeFlow.collectAsStateWithLifecycle(null)
    val refreshInterval by appSettingsViewModel.playlistRefreshIntervalFlow.collectAsStateWithLifecycle(null)
    val lastUpdated     by appSettingsViewModel.lastUpdatedDataDate.collectAsStateWithLifecycle(null)

    // ── Strings ───────────────────────────────────────────────────────────────
    val generalTitle            = Res.string.general
    val languageTitle           = Res.string.language
    val chooseLanguageDesc      = Res.string.chose_language
    val themeTitle              = Res.string.theme
    val chooseThemeDesc         = Res.string.chose_app_theme
    val resumeTitle             = Res.string.resume_last_played_activity
    val resumeDesc              = Res.string.resume_last_playback_desc
    val playerTitle             = Res.string.player
    val useHttpsTitle           = Res.string.always_use_https
    val useHttpsDesc            = Res.string.always_use_https_desc
    val streamFormatTitle       = Res.string.stream_format
    val scalingModeTitle        = Res.string.video_scaling_mode
    val videoRenderModeTitle    = Res.string.video_render_mode
    val userDataTitle           = Res.string.user_data
    val refreshIntervalTitle    = Res.string.refresh_data_interval
    val refreshPlaylistTitle    = Res.string.refresh_playlist_title
    val reorderLiveTvsTitle        = Res.string.reorder_tv_channels
    val showHideCategoryTitle        = Res.string.show_and_hide_categoires
    val clearLiveHistoryTitle   = Res.string.clear_watched_live_tv_history
    val clearVodHistoryTitle    = Res.string.clear_watched_movies_history
    val clearSeriesHistoryTitle = Res.string.clear_watched_series_history
    val logoutTitle             = Res.string.logout
    val confirmationTitle       = Res.string.yes
    val cancelTitle             = Res.string.no


    val liveTitle             = Res.string.live
    val movieTitle             = Res.string.movies
    val seriesTitle             = Res.string.series
    // ── Option maps ───────────────────────────────────────────────────────────
    val showHideCategoryMap = remember {
        mapOf(
            "0" to liveTitle,
            "1" to movieTitle,
            "2" to seriesTitle,

            )
    }
    val confirmationMap = mapOf("1" to confirmationTitle, "0" to cancelTitle)

    val languageMap = stringArrayResource(Res.array.language_keys)
        .zip(stringArrayResource(Res.array.language_titles)).toMap()

    val themeMap = listOf(AppTheme.DARK, AppTheme.LIGHT, AppTheme.SYSTEM)
        .map { it.name }.zip(stringArrayResource(Res.array.theme_titles)).toMap()

    val liveStreamFormatMap = stringArrayResource(Res.array.live_stream_formats)
        .zip(stringArrayResource(Res.array.live_stream_formats)).toMap()

    val videoScalingModeMap = stringArrayResource(Res.array.video_player_resize_modes)
        .zip(stringArrayResource(Res.array.video_player_resize_mode_titles)).toMap()

    val videoRenderModeMap = stringArrayResource(Res.array.video_render_modes)
        .zip(stringArrayResource(Res.array.video_render_mode_titles)).toMap()

    val refreshPlayListIntervalMap = stringArrayResource(Res.array.refresh_data_intervals_values)
        .zip(stringArrayResource(Res.array.refresh_data_intervals)).toMap()

    val themeChangeAllowed =  isDpadNavigation()

    /*LaunchedEffect(lastUpdated) {
        Log.d("lastUpdated", "rememberPreferencesList: $lastUpdated")
    }*/
    // ── Build list — keyed on every state value so it rebuilds on any change ──
    return remember(
        language, appTheme, resumeEnabled, alwaysHttps,
        streamFormat, scalingMode, renderMode, refreshInterval, lastUpdated,
        languageMap, themeMap, liveStreamFormatMap, videoScalingModeMap, videoRenderModeMap, refreshPlayListIntervalMap    ) {
        buildList {

            // ── General ───────────────────────────────────────────────────────
            add(PreferenceCategoryAction(title = generalTitle))

            add(PreferenceRadioAction(
                title = languageTitle,
                description = chooseLanguageDesc,
                currentValue = language,                // ✅ plain state
                icon = Icons.Filled.Translate,
                options = languageMap,
                key = PreferencesRepo.LANGUAGE_KEY.name,
                onItemSelected = { k, _ ->
                     //activity.saveLocaleToPrefs(k)
                    appSettingsViewModel.setLanguage(k) {
                        //activity.setupLocale(null)
                      //  activity.restartActivity(Build.VERSION.SDK_INT >= Build.VERSION_CODES.TIRAMISU)
                    }
                }
            ))

            if (themeChangeAllowed) add(PreferenceRadioAction(
                title = themeTitle,
                description = chooseThemeDesc,
                currentValue = appTheme?.name,           // ✅ plain state
                icon = Icons.Filled.ColorLens,
                options = themeMap,
                key = PreferencesRepo.APP_THEME_KEY.name,
                onItemSelected = { k, _ -> appSettingsViewModel.setAppTheme(k) }
            ))

            add(PreferenceSwitchAction(
                title = resumeTitle,
                description = resumeDesc,
                icon = Icons.Filled.WatchLater,
                currentValue = resumeEnabled,           // ✅ plain state
                key = PreferencesRepo.LAST_PLAYED_ACTIVITY_ENABLED_KEY.name,
                onCheckedChange = { appSettingsViewModel.setResumeLastPlayedActivityEnabled(it) }
            ))

            // ── Player ────────────────────────────────────────────────────────
            add(PreferenceCategoryAction(title = playerTitle))

            add(PreferenceSwitchAction(
                title = useHttpsTitle,
                description = useHttpsDesc,
                icon = Icons.Filled.Https,
                currentValue = alwaysHttps,             // ✅ plain state
                key = PreferencesRepo.ALWAYS_USE_HTTPS_KEY.name,
                onCheckedChange = { appSettingsViewModel.setIsAlwaysUseHTTPS(it) }
            ))

            add(PreferenceRadioAction(
                title = streamFormatTitle,
                description = streamFormatTitle,
                currentValue = streamFormat,            // ✅ plain state
                icon = Icons.Filled.VideoSettings,
                options = liveStreamFormatMap,
                key = PreferencesRepo.LIVE_STREAM_FORMAT_KEY.name,
                onItemSelected = { k, _ -> appSettingsViewModel.setLiveStreamFormat(k) }
            ))

            add(PreferenceRadioAction(
                title = scalingModeTitle,
                description = scalingModeTitle,
                currentValue = scalingMode.toString(),  // ✅ plain state
                icon = Icons.Filled.PhotoSizeSelectLarge,
                options = videoScalingModeMap,
                key = PreferencesRepo.VIDEO_SCALING_MODE_KEY.name,
                onItemSelected = { k, _ -> appSettingsViewModel.setVideoScalingMode(k.toIntOrNull()) }
            ))

            add(PreferenceRadioAction(
                title = videoRenderModeTitle,
                description = videoRenderModeTitle,
                currentValue = renderMode.toString(),   // ✅ plain state
                icon = Icons.Filled.VideoSettings,
                options = videoRenderModeMap,
                key = PreferencesRepo.VIDEO_RENDER_MODE_KEY.name,
                onItemSelected = { k, _ -> appSettingsViewModel.setVideoRenderMode(k.toIntOrNull()) }
            ))

            // ── User Data ─────────────────────────────────────────────────────
            add(PreferenceCategoryAction(title = userDataTitle))

            add(PreferenceRadioAction(
                title = refreshIntervalTitle,
                description = refreshIntervalTitle,
                currentValue = refreshInterval,         // ✅ plain state
                icon = Icons.Filled.Timelapse,
                options = refreshPlayListIntervalMap,
                key = PreferencesRepo.PLAYLIST_REFRESH_INTERVAL_KEY.name,
                onItemSelected = { k, _ -> appSettingsViewModel.setPlaylistRefreshInterval(k) }
            ))

            add(PreferenceChoiceAction(
                title = refreshPlaylistTitle,
               // description = refreshPlaylistTitle.plus(": $lastUpdated"),
                //currentValue = lastUpdated,             // ✅ plain state — never null now
                prefType = PreferenceType.CONFIRMATION,
                icon = Icons.Filled.WatchLater,
                key = PreferencesRepo.LAST_DATA_UPDATE_MILlIS_KEY.name,
                options = confirmationMap,
                onItemSelected = { k, _ ->
                    if (k == "1") scope.launch {        // ✅ Main scope — no Dispatchers.Default for UI call
                        userViewModel.resetLastDataUpdateTime() {
                            appSettingsViewModel.setSkipAccountRefresh(true) {
                                rootNavViewModel.backStack.clear()
                                rootNavViewModel.backStack.add(
                                    Screen.Loading(
                                        forceRefreshData = true,
                                        skipUserRefresh = true
                                    )
                                )
                            }
                        }
                    }
                }
            ))
            add(PreferenceButtonAction(
                title = reorderLiveTvsTitle,
                // description = refreshPlaylistTitle.plus(": $lastUpdated"),
                //currentValue = lastUpdated,             // ✅ plain state — never null now
                icon = Icons.Filled.SwapVert,
                key = "reorderLiveTvsTitle",
                onClick = {
                    rootNavViewModel.navigate(Screen.ChoseTvCategory)

                }
            ))

            add(
                PreferenceChoiceAction(
                    title = showHideCategoryTitle,
                    // description = refreshPlaylistTitle.plus(": $lastUpdated"),
                    //currentValue = lastUpdated,             // ✅ plain state — never null now
                    prefType = PreferenceType.CONFIRMATION,
                    icon = Icons.Filled.Visibility,
                    key = "showHideCategoryTitle",
                    options = showHideCategoryMap,
                    onItemSelected = { k, _ ->
                        val type=  when(k){

                            "1"->   StreamType.MOVIE
                            "2"->   StreamType.SERIES
                            else->    StreamType.LIVE
                        }
                        rootNavViewModel.navigate(Screen.ManageCategories(type))
                    }
                ))
            add(PreferenceChoiceAction(
                title = clearLiveHistoryTitle,
                 prefType = PreferenceType.CONFIRMATION,
                icon = Icons.Filled.DeleteSweep,
                key = "clearLiveHistoryTitle",
                options = confirmationMap,
                onItemSelected = { k, _ ->
                    if (k == "1") liveStreamsViewModel.clearWatched() }
            ))

            add(PreferenceChoiceAction(
                title = clearVodHistoryTitle,
                 prefType = PreferenceType.CONFIRMATION,
                icon = Icons.Filled.DeleteSweep,
                key = "clearVodHistoryTitle",
                options = confirmationMap,
                onItemSelected = { k, _ -> if (k == "1") vodStreamsViewModel.clearWatched() }
            ))

            add(PreferenceChoiceAction(
                title = clearSeriesHistoryTitle,
                 prefType = PreferenceType.CONFIRMATION,
                icon = Icons.Filled.DeleteSweep,
                key = "clearSeriesHistoryTitle",
                options = confirmationMap,
                onItemSelected = { k, _ -> if (k == "1") seriesStreamsViewModel.clearWatched() }
            ))

            add(PreferenceChoiceAction(
                title = logoutTitle,
                 prefType = PreferenceType.CONFIRMATION,
                icon = Icons.AutoMirrored.Filled.Logout,
                key = "logoutTitle",
                options = confirmationMap,
                onItemSelected = { k, _ ->
                    if (k == "1") scope.launch {        // ✅ Main scope
                        withContext(Dispatchers.Default) {
                            userViewModel.logOut()
                            userViewModel.resetLastDataUpdateTime() {
                                appSettingsViewModel.setSkipAccountRefresh(false) {
                                    rootNavViewModel.backStack.clear()
                                    rootNavViewModel.backStack.add(
                                        Screen.Loading(
                                            forceRefreshData = true,
                                            skipUserRefresh = false
                                        )
                                    )
                                }
                            }
                        }
                        //TODO()
                        //activity.restartActivity(false)  // ✅ back on Main for UI
                    }
                }
            ))
        }
    }
}